export default {
  extractAnsweredQuotesIds({ commit }, answeredQuotes) {
    const answeredQuotesIds = [];
    Object.entries(answeredQuotes).forEach(([key, value]) => {
      let previousIteratedQuote;
      let quoteIdentifier = 1;

      // eslint-disable-next-line no-restricted-syntax
      for (const quote of value.cotacoes) {
        const quoteId = quote.id;

        if (quote.cot_cotacao_id !== previousIteratedQuote) {
          quoteIdentifier = 1;
        } else {
          ++quoteIdentifier;
        }

        previousIteratedQuote = quote.cot_cotacao_id;
        answeredQuotesIds.push({ quoteId, quoteIdentifier });
      }
    });

    commit('setAnsweredQuotesIds', answeredQuotesIds);
  },
};
